<ng-template #showModalAcceptGivi let-modal>

    <div class="modal-body">

        <div class="text-center">
            <div>
                <!-- <div *ngIf="points">
                    <img class="coupon-image" src="{{productImage}}"> -->
                    <!-- <div class="center-text">
                        <span class="small-image"></span>
                        <span>{{points}}</span>
                        <span class="font-h7">pts</span>
                    </div> -->
                <!-- </div> -->

                <div class="w-100" >
                    <div class="img-container">
                        <div class="img-bg d-flex-center">
                            <img src="assets/images/GiviBITFormat3.png" style="height: 100%;">
                            <img [src]="productImage" alt="Carga tu foto aquí" class="img-coupon"/> 
                        </div>
                    </div>
                </div>  
                <!-- <img src="{{productImage}}" class="image-coupon" *ngIf="!points"> -->
                <!-- <div class="modal-title">{{productName}}</div> -->
                <div class="font-b1 m-t-10">¡Gracias por unirte a la familia de Givi!</div>
                <div class="font-c1 m-t-10">Te regalamos este cupón de bienvenida.</div>
                <div class="font-c1 m-t-10">
                    ¿Querés más BITs (Cupones)? La clave está en entrar a diario. 
                    ¡Ingresá mañana y encontrarás uno nuevo en Givi!
                </div>
            </div>

            <!-- button submit -->
            <div class="d-flex justify-content-between m-t-15 m-b-20">
                <button class="btn btn-outline-primary button-custom" (click)="closeModal()">DESCUBRIR MÁS</button>
                <button class="btn btn-primary button-custom" (click)="acceptMyGivi()">ACEPTAR GIVI</button>
            </div>
        </div>
    </div>
</ng-template>